import { Outlet, Navigate } from 'react-router-dom'
import globalStore from 'store'
import { EUserRole } from 'models/user.model'

const ProtectedRoutesByRegister = ({ status }: { status: 'completed' | 'pending' }) => {
  const register = globalStore(state => state.register)
  const user = globalStore(state => state.user)

  if (!register) return <Navigate to="" />

  if (!user) return <Navigate to="/signin" />

  if (user.role === EUserRole.ADMIN) return <Outlet />

  if (register.status !== status) return <Navigate to="/redirect" />

  return <Outlet />
}
export default ProtectedRoutesByRegister
